import React, { useEffect, useState,useRef } from "react";
import "../../index.css";
import "./Header.css";
import Search from "../../images/search-icon.png";
// import Sidebar from "../Sidebar/Sidebar";

const Header = () => {
  const [show, setShow] = useState(false);
  
  
const catMenu = useRef(null);
const closeOpenMenus = (e)=>{
  if(catMenu.current && show && !catMenu.current.contains(e.target)){
    setShow(false)
  }
}
 const set = document.addEventListener('mousedown',closeOpenMenus)

  return (
    <>
      <header>
        <div className="main-logo-wrapper">
          <div className="main-logo">
            <h3>BigWing</h3>
          </div>
        </div>
        <div className="hamburger-menu">
          {/* <Sidebar/> */}
          <div  className={!show ? "hamburger" : "hamburger hide"} onClick={() => setShow(!show)}>
            <div className="white"></div>
            <div className="white"></div>
            <div className="white"></div>
          </div>
          
            <div  ref={catMenu} className={show ? "sidebar-wrapper" : "sidebar-wrapper  mb"}>
              <div className="Opts">Home</div>
              <div className="Opt">About</div>
              <div className="Opt">Service</div>
              <div className="Opt">Contact Us</div>
              <div className="Opt">Log Out</div>
            </div>
        
        </div>
        <div className="menuOpt-search">
          <div className="menu-opts-wrapper">
            <div className="menu-otps">
              <span className="menu-otp">Home</span>
              <span className="menu-otp">About</span>
              <span className="menu-otp">Service</span>
              <span className="menu-otp">Contact Us</span>
            </div>
          </div>
          <div className="search-bar-wrapper flex">
            <div className="search-bar">
              <input className="search" type="Search" />
            </div>
            <img className="border" src={Search} alt="" />
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
